import { useEffect } from 'react';
import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/dist/ScrollTrigger';
import { useRouter } from 'next/router';

export const useHeaderAnimation = () => {
  const { route } = useRouter();
  useEffect(() => {
    gsap.registerPlugin(ScrollTrigger);
    const isCheckout = false;
    const ctx = gsap.context(() => {
      const animTrigger = {
        trigger: 'header',
        start: 1,
        end: 1,
        toggleActions: 'play none reverse none',
        pin: false,
      };
      const animDuration = 0.2;

      ScrollTrigger.matchMedia({
        '(min-width: 1171px)': () => {
          gsap
            .timeline({ scrollTrigger: animTrigger })
            .from('.home header', {
              duration: animDuration,
              backgroundColor: 'rgb(255 255 255 / 70%)',
            })
            // Dureation of 0 prevents flicker caused by abovePromo banner on scroll
            .to('.home header', { duration: 0, backgroundColor: '#FFFFFF' });

          gsap
            .timeline({ scrollTrigger: animTrigger })
            .from(
              '#app:not(.checkout) .header',
              { duration: animDuration, paddingBlock: 24 },
              `-=${animDuration}`,
            )
            .to('#app:not(.checkout) .header', { duration: animDuration, paddingBlock: 6 });
          gsap
            .timeline({ scrollTrigger: animTrigger })
            .to('header', { duration: animDuration, top: 0 });
          gsap
            .timeline({ scrollTrigger: animTrigger })
            .to('header', { duration: animDuration, paddingBlock: 15 });
          gsap
            .timeline({ scrollTrigger: animTrigger })
            .to(':not(.home) header', { duration: 0, backgroundColor: '#FFFFFF' });
          gsap.set('#app:not(.checkout) .header', { clearProps: 'all' });
          gsap.set('header', { clearProps: 'all' });
          gsap.set('.header .main-logo a', { clearProps: 'all' });

          // Add hover state animation
          const homeHeader = document.querySelector('.home header');
          if (homeHeader) {
            const aboveBanner = document.querySelector<HTMLDivElement>('.above-promo.earn-burn');
            if (window.scrollY === 0) {
              gsap.set('header', { top: aboveBanner?.offsetHeight });
            }
            homeHeader.addEventListener('mouseenter', () => {
              gsap.to(homeHeader, { backgroundColor: '#FFFFFF', duration: animDuration });
            });
            homeHeader.addEventListener('mouseleave', () => {
              if (
                !homeHeader.classList.contains('scrolled') &&
                !homeHeader.querySelector('.sub-menu.visible')
              ) {
                gsap.to(homeHeader, {
                  backgroundColor: 'rgb(255 255 255 / 70%)',
                  duration: animDuration,
                });
              }
            });
          }
        },
        '(max-width: 1170px)': () => {
          gsap.set('.header', { clearProps: 'all' });
          gsap.set('header', { clearProps: 'all' });
          gsap.set('.header .main-logo a', { clearProps: 'all' });
        },
      });
    });
    if (isCheckout) {
      ctx.revert();
    }
    return () => ctx.revert();
  }, [route]);
};

export default useHeaderAnimation;
